import Modal from '../Modal';

/**
 * Confirms offering a theme to every business on Breely.
 *
 * Worth confirming because there is no way back: once it has been public the
 * theme can never be edited or deleted again, even if it is later unpublished,
 * since other businesses' forms may come to depend on it.
 */
const MakeThemePublicModal = ({
    isOpen,
    onClose,
    onConfirm,
    theme,
    isSaving,
}) => {
    return (
        <Modal isOpen={isOpen} onClose={onClose} widthClass="max-w-md">
            <h2 className="text-2xl font-semibold text-center mb-6">
                Make Theme Public
            </h2>

            <div className="text-[17px] text-gray-700">
                Are you sure you want to make{' '}
                <span className="font-bold">{theme?.name}</span> public?
            </div>

            <div className="text-sm text-gray-500 mt-3">
                Every business on Breely will be able to use it.{' '}
                {theme?.isUnpublished
                    ? 'It already cannot be edited, renamed or deleted, since it has been public before.'
                    : 'It can no longer be edited, renamed or deleted — even if you unpublish it later.'}
            </div>

            <div className="flex items-center gap-3 mt-6">
                <button
                    type="button"
                    className="btn-save"
                    onClick={onConfirm}
                    disabled={isSaving}
                >
                    {isSaving ? 'Publishing…' : 'Make Theme Public'}
                </button>
                <button
                    type="button"
                    className="btn-gray-pill-lg"
                    onClick={onClose}
                    disabled={isSaving}
                >
                    Cancel
                </button>
            </div>
        </Modal>
    );
};

export default MakeThemePublicModal;
